import { Button } from '@pella/sash-framework';
import * as classes from './TransactionItemsList.module.css';

/**
 * Component to display a list of transaction items.
 * @param {Local.TransactionItemListProps} props - Component props
 */
export const TransactionItemsList = ({ items, onDelete }) => {
  if (!items?.length) return null;

  const showTransferColumn = items.some((item) => item.transferSubinventory);
  const rowClass = showTransferColumn ? `${classes.row} ${classes.transferRow}` : classes.row;

  return (
    <div className={classes.wrapper}>
      <h3 className={classes.title}>Transaction Items</h3>
      <div className={`${rowClass} ${classes.header}`}>
        <span>Item</span>
        <span>Quantity</span>
        {showTransferColumn ? (
          <>
            <span>Sub Inv To</span>
            <span>Sub Inv From</span>
          </>
        ) : (
          <span>Sub Inventory</span>
        )}
        <span>UOM</span>
        <span />
      </div>
      {items.map((item) => (
        <div key={item.id} className={rowClass}>
          <span>{item.item}</span>
          <span>{item.transactionQuantity * -1}</span>
          {showTransferColumn ? (
            <>
              <span>{item.transferSubinventory}</span>
              <span>{item.subinventoryCode}</span>
            </>
          ) : (
            <span>{item.subinventoryCode}</span>
          )}
          <span>{item.unitOfIssueCode}</span>
          <span>
            <Button
              aria-label={`Delete transaction item ${item.item}`}
              data-testid={`delete-transaction-item-${item.id}`}
              color='tertiary'
              iconLeft='delete'
              onClick={() => onDelete(item.id)}
            />
          </span>
        </div>
      ))}
    </div>
  );
};
